import React from 'react';
import { Button, Result } from 'antd';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../redux/auth/actions';
import forbidden from '../../assets/icons/403.svg';

const AccessDenied = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { pathname } = useLocation();

  const subTitle = pathname.startsWith('/admin')
    ? 'Platform pages are for the SeeWard platform team.'
    : 'Your role here doesn\'t include this page. Ask an administrator of your organisation if you need it.';

  return (
    <div className="flex justify-center p-8">
      <Result
        icon={
          <div className="flex justify-center">
            <img src={forbidden} alt="" className="w-[160px]" />
          </div>
        }
        title="You don't have access to this page"
        subTitle={subTitle}
        extra={[
          <Button key="home" type="primary" onClick={() => navigate('/')}>
            Go to my organisation
          </Button>, <Button key="switch" onClick={() => dispatch(logout())}>
            Switch account
          </Button>
        ]}
      />
    </div>
  );
};

export default AccessDenied;
